import React, { Fragment } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import _ from "lodash";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { withRouter } from "react-router-dom";
import HeaderLogo from "../AppLogo";

import { setEnableSearchBarOnHeader } from "../../reducers/ThemeOptions";
import SearchBox from "./Components/SearchBox";
import Support from "./Components/Support";
import UserBox from "./Components/UserBox/UserBox";
import detect_mobile from "../../utils/detect_mobile";
const SHOWUPGRADE_URL = localStorage.getItem("SHOWUPGRADE");
const SHOWUPGRADE = SHOWUPGRADE_URL !== "undefined";
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFullscreen: false,
      showBanner: true,
    };
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }

  componentDidMount() {
    this.updateHeaderHeight();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.showBanner !== this.state.showBanner) {
      this.updateHeaderHeight();
    }
  }

  componentWillUnmount() {
    document.documentElement.style.setProperty("--header-height", "68px");
  }

  updateHeaderHeight = () => {
    const baseHeaderHeight = 68;
    const bannerHeight = this.state.showBanner && SHOWUPGRADE ? 68 : 0;
    document.documentElement.style.setProperty("--base-header-height", `${baseHeaderHeight}px`);
    document.documentElement.style.setProperty("--banner-height", `${bannerHeight}px`);
    document.documentElement.style.setProperty("--header-height", `${baseHeaderHeight + bannerHeight}px`);
  };


  closeBanner = () => {
    this.setState({ showBanner: false }, () => {
      this.updateHeaderHeight();
    });
  };

  toggleFullscreen() {
    const elem = document.documentElement;
    if (!this.state.isFullscreen) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
      this.setState({ isFullscreen: true });
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
      this.setState({ isFullscreen: false });
    }
  }

  render() {
    const {
      headerBackgroundColor,
      enableHeaderShadow,
      openInput,
      setEnableSearchBarOnHeader,
      page_config,
    } = this.props;

    const { isFullscreen, showBanner } = this.state;

    const show_search_bar = _.get(page_config, "header.show_search_bar", false);
    const show_support = _.get(page_config, "header.show_support", false);

    const checkPath = () => {
      const location = _.get(this.props, "location.pathname", "");
      if (location.includes("alert")) return "Alerts";
      if (location.includes("parties")) return "Parties";
      if (location.includes("portfolios")) return "Portfolios";
      if (location.includes("cases")) return "Cases";
      if (location.includes("products")) return "Products";
      return null;
    };

    return (
      <Fragment>
        {showBanner && SHOWUPGRADE && (
          <div
            className="alert bg-primary text-white alert-dismissible fade show fixed-top d-flex justify-content-between align-items-center mb-0 px-4"
            role="alert"
          >
            <strong className="me-3 flex-grow-1 text-center">
              <a
                rel="noopener noreferrer"
                className="text-white text-decoration-none"
              >
                <span className="me-2 text-warning">
                  <i className="fas fa-star"></i>
                </span>
                Heads-up: a better version of Crediwatch is almost here. Watch
                this space for updates — Beta launch planned for 17 September 2025
              </a>
            </strong>

            <button
              type="button"
              className="btn text-white p-0 ms-3"
              aria-label="Close"
              onClick={this.closeBanner}
            >
              <span aria-hidden="true" className="h4 m-0">&times;</span>
            </button>
          </div>
        )}

        {/* Main Header */}
        <CSSTransitionGroup
          component="div"
          className={cx(
            "app-header",
            headerBackgroundColor,
            { "header-shadow": enableHeaderShadow },
            `${detect_mobile() ? "bg-lightBlue" : ""}`
          )}
          style={{
            marginTop: showBanner && SHOWUPGRADE ? 68 : 0,
            transition: "margin-top 0.3s ease",
          }}
          transitionName="HeaderAnimation"
          transitionAppear={true}
          transitionAppearTimeout={1500}
          transitionEnter={false}
          transitionLeave={false}
        >
          {!openInput && <HeaderLogo />}
          <div className="d-block d-md-none w-100">
            <div className="d-flex justify-content-end">
              <div className="heading-mobile-header">{checkPath()}</div>
            </div>
          </div>

          <div className="d-flex justify-content-end w-100 align-items-center">
            <div id="cwi_header_bar__search" className="flex-grow-1 mx-3">
              {show_search_bar && (
                <SearchBox
                  openInput={openInput}
                  setEnableSearchBarOnHeader={setEnableSearchBarOnHeader}
                />
              )}
            </div>

            {show_support && !openInput && (
              <div className="d-none d-md-block">
                <Support />
              </div>
            )}

            <i
              className={`fa-solid ${isFullscreen ? "fa-compress" : "fa-expand"
                } text-primary m-2 fs-24 d-none d-md-block cursor-pointer`}
              onClick={this.toggleFullscreen}
            ></i>

            <UserBox log_out={this.log_out} />
          </div>
        </CSSTransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  page_config: _.get(state, "my_profile.page_config", {}),
  searchBar: _.get(state, "globalReducer.searchbar"),
});

const mapDispatchToProps = (dispatch) => ({
  setEnableSearchBarOnHeader: (value) =>
    dispatch(setEnableSearchBarOnHeader(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Header));
